export default __webpack_public_path__ + "static/media/SmartSplitter.256.5e147776.png";